export const enum ViewBy {
  LIST_VIEW = "List View",
  ROADMAP_VIEW = "Roadmap View",
  ROADMAP_SETTINGS = "Roadmap Settings",
}
